






































import coreApiClient from "@/services/apis/coreApiClient";
import Vue from "vue";
import centrifugeClientFactory from "@/services/centrifugeClientFactory";
import merge from "@common/modules/vuetifyx/utils/merge";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import QRCode from "qrcode";
import { downloadUri } from "@common/util/download";
import userManager from "@/services/userManager";
import store from "@/plugins/store";

export default Vue.extend({
  props: ["item"],
  data() {
    const isTariffEnabled = !!store.state.featureConfig?.multiTierPricing?.enabled;
    const self = this;
    const self2 = this;
    const elementTypeItems = [
      { text: "ENERGY", value: "ENERGY" },
      { text: "PARKING TIME", value: "PARKING_TIME", disabled: !store.state.featureConfig?.multiTierPricing?.slowDisconnectPenaltyEnabled },
    ];
    return {
      self,
      updatedItem: null,
      tableContainer: new DataContainer(),

      assignDialog: false,
      assignLoading: false,
      assignForm: {
        connectorId: null as number | null,
        napasMerchantId: "",
      },
      availableMerchants: [] as any[],
      loadingMerchants: false,
      napasSnackbar: {
        show: false,
        text: "",
        color: "success",
      },

      tableOptions: {
        attrs: {
          "item-key": "connectorId",
          "hide-default-footer": true,
        },
        content: {
          displayFields: {
            connectorId: {
              text: "Connector ID",
            },
            qrCode: {
              text: "QR Code",
              options: {
                transform(_, item) {
                  const connectorId = item.connectorId;
                  const setting =
                    self.item.connectorSettingItems?.[connectorId - 1];
                  return setting && setting.qrCode;
                },
              },
            },
            status: {
              text: "Status",
              options: {
                label: true,
                attrs: {
                  color: "primary",
                  outlined: true,
                },
              },
            },
            type: {
              text: "Type",
              options: {
                label: true,
                attrs: {
                  color: "info",
                  outlined: true,
                },
                transform(_, item) {
                  const connectorId = item.connectorId;
                  const setting =
                    self.item.connectorSettingItems?.[connectorId - 1];
                  return setting?.typeName || 'Type 1';
                },
              },
            },
            action: {
              text: "Actions",
            },
          },
          template: {
            itemActionButtons: {
              startCharging: {
                content: {
                  icon: "mdi-play-circle",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Start Charging",
                    },
                  },
                  confirm: {
                    content: {
                      content: {
                        html: "Are you sure you want to start charging?",
                      },
                    },
                    on: {
                      async xYes({ self }) {
                        const yesBtn = self.yesBtnContainer.value;
                        const btn = self.context();
                        const { dataTable, item } = btn.context();
                        const { item: parentItem } = dataTable.context();
                        yesBtn.loading.value = true;
                        const result = await dataTable.execute(
                          async () => {
                            return await coreApiClient.call(
                              "chargingStations",
                              "startCharging",
                              {
                                id: parentItem._id,
                                connectorId: item.connectorId,
                              }
                            );
                          },
                          undefined,
                          {
                            disableLoading: true,
                            willRefresh: true,
                          }
                        );
                        yesBtn.loading.value = false;
                        if (result) {
                          self.hide();
                        }
                      },
                    },
                  },
                },
                ext: {
                  condition(dataTable, item) {
                    return ["Available", "Preparing"].includes(item.status) && item.deviceType === 'charging-station';
                  },
                },
              },
              stopCharging: {
                content: {
                  icon: "mdi-stop-circle",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Stop Charging",
                    },
                  },
                  confirm: {
                    content: {
                      content: {
                        html: "Are you sure you want to stop charging?",
                      },
                    },
                    on: {
                      async xYes({ self }) {
                        const yesBtn = self.yesBtnContainer.value;
                        const btn = self.context();
                        const { dataTable, item } = btn.context();
                        const { item: parentItem } = dataTable.context();
                        yesBtn.loading.value = true;
                        const result = await dataTable.execute(
                          async () => {
                            return await coreApiClient.call(
                              "chargingStations",
                              "stopCharging",
                              {
                                id: parentItem._id,
                                connectorId: item.connectorId,
                              }
                            );
                          },
                          undefined,
                          {
                            disableLoading: true,
                            willRefresh: true,
                          }
                        );
                        yesBtn.loading.value = false;
                        if (result) {
                          self.hide();
                        }
                      },
                    },
                  },
                },
                ext: {
                  condition(dataTable, item) {
                    return ["Charging"].includes(item.status);
                  },
                },
              },
              viewChargingDetails: {
                content: {
                  icon: "mdi-battery-charging",
                },
                on: {
                  xClick({ self }) {
                    const { dataTable, item } = self.context();
                    const { $router, item: parentItem } = dataTable.context();
                    $router.push({
                      path: `/app/charging_details/${parentItem._id}/${item.connectorId}`,
                    });
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "View Charging Details",
                    },
                  },
                },
              },
              viewConnectorDetails: !self.item.isPrivate && {
                content: {
                  icon: "mdi-connection",
                },
                on: {
                  xClick({ self }) {
                    const { dataTable, item } = self.context();
                    const { $router, item: parentItem } = dataTable.context();
                    $router.push({
                      path: `/app/charging_stations/${parentItem._id}/${item.connectorId}`,
                    });
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "View Connector Details",
                    },
                  },
                },
              },
              downloadQr: !self.item.isPrivate && {
                content: {
                  icon: "mdi-qrcode",
                },
                on: {
                  async xClick({ self }) {
                    const { dataTable, item } = self.context();
                    const { item: chargingStation } = dataTable.context();
                    const setting = self2.item.connectorSettingItems[item.connectorId - 1];
                    const qrCode = setting && setting.qrCode;
                    const dataUrl = await QRCode.toDataURL(qrCode, {
                      width: 500,
                    });
                    downloadUri(
                      dataUrl,
                      `charging_station_${chargingStation.uniqueId}_${item.connectorId}.png`
                    );
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Download QR Code",
                    },
                  },
                },
              },
              downloadQr2: self.item.isPrivate && {
                content: {
                  icon: "mdi-qrcode",
                },
                on: {
                  async xClick({ self }) {
                    const { item } = self.context();
                    const setting =
                      self2.item.connectorSettingItems?.[item.connectorId - 1];
                    const qrCode = setting && setting.qrCode;
                    const dataUrl = await QRCode.toDataURL(qrCode, {
                      width: 500,
                    });
                    downloadUri(
                      dataUrl,
                      `charging_station_${self2.item.uniqueId}_${item.connectorId}.png`
                    );
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Download QR Code (Private)",
                    },
                  },
                },
                ext: {
                  condition(dataTable, item) {
                    const setting =
                      self.item.connectorSettingItems?.[item.connectorId - 1];
                    return setting && setting.qrCode;
                  },
                },
              },
              downloadNapasQr: {
                content: {
                  icon: "mdi-qrcode-scan",
                },
                on: {
                  async xClick({ self }) {
                    const { item } = self.context();
                    const setting =
                      self2.updatedItem?.connectorSettingItems?.[item.connectorId - 1];
                    const qrCode = setting && setting.napasQrCode;
                    const dataUrl = await QRCode.toDataURL(qrCode, {
                      width: 500,
                    });
                    downloadUri(
                      dataUrl,
                      `charging_station_${self2.item.uniqueId}_${item.connectorId}.png`
                    );
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Download Napas QR Code",
                    },
                  },
                },
                ext: {
                  condition(dataTable, item) {
                    if (!store.state.featureConfig?.applessPayment?.enabled) {
                      return false;
                    }
                    const setting =
                      self2.updatedItem?.connectorSettingItems?.[item.connectorId - 1];
                    return !!setting?.napasQrCode;
                  },
                },
              },
              assignNapasMerchant: userManager.checkRole([
                "systemAdmin",
                "admin",
                "cpoAdmin",
              ]) && {
                content: {
                  icon: "mdi-account-plus",
                  color: "primary",
                },
                on: {
                  xClick({ self: btnSelf }) {
                    const { item } = btnSelf.context();
                    self2.openAssignDialog(item.connectorId);
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Assign Napas Merchant",
                    },
                  },
                },
                ext: {
                  condition(dataTable, item) {
                    if (!store.state.featureConfig?.applessPayment?.enabled) {
                      return false;
                    }
                    const setting =
                      self2.updatedItem?.connectorSettingItems?.[item.connectorId - 1];
                    return !setting?.napasMerchantId;
                  },
                },
              },
              unassignNapasMerchant: userManager.checkRole([
                "systemAdmin",
                "admin",
                "cpoAdmin",
              ]) && {
                content: {
                  icon: "mdi-account-remove",
                  color: "warning",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Unassign Napas Merchant",
                    },
                  },
                  confirm: {
                    content: {
                      content: {
                        html: "Are you sure you want to unassign the Napas merchant from this connector? The associated Napas QR code will be cleared.",
                      },
                    },
                    on: {
                      async xYes({ self: confirmSelf }) {
                        const yesBtn = confirmSelf.yesBtnContainer.value;
                        const btn = confirmSelf.context();
                        const { item } = btn.context();
                        const setting =
                          self2.updatedItem?.connectorSettingItems?.[item.connectorId - 1];
                        const napasMerchantId = setting?.napasMerchantId;
                        if (!napasMerchantId) {
                          confirmSelf.hide();
                          return;
                        }
                        yesBtn.loading.value = true;
                        try {
                          await coreApiClient.call(
                            "napasMerchants",
                            "unbind",
                            { napasMerchantId }
                          );
                          await self2.reloadStation();
                          self2.showNapasSnackbar("Unassigned successfully", "success");
                          confirmSelf.hide();
                        } catch (e) {
                          self2.showNapasSnackbar(
                            (e as any)?.response?.data?.message || "Unassign failed",
                            "error"
                          );
                        } finally {
                          yesBtn.loading.value = false;
                        }
                      },
                    },
                  },
                },
                ext: {
                  condition(dataTable, item) {
                    if (!store.state.featureConfig?.applessPayment?.enabled) {
                      return false;
                    }
                    const setting =
                      self2.updatedItem?.connectorSettingItems?.[item.connectorId - 1];
                    return !!setting?.napasMerchantId;
                  },
                },
              },
              tariff: userManager.checkRole([
                  "systemAdmin",
                  "admin",
                  "cpoAdmin",
                  "cpoMonitor",
                  "retailer"
              ])  && isTariffEnabled && {
                  content: {
                     icon: "mdi-cash-clock",
                  },
                  // target: {
                  //   tooltip: {
                  //     content: {
                  //       text: "Tariff",
                  //     },
                  //   },
                  // },
                  target: {
                      dialog: {
                          attrs: {
                              width: "600px",
                          },
                          content: {
                              toolbar: {
                                  title: "Tariff",
                              },
                              content: {
                                  type: "XForm",
                                  makeAttrs: (attrs, dialog) => {
                                      attrs.xContext = dialog;
                                      const { item: connector } = dialog
                                          .context()
                                          .context();

                                      const { item: chagingStation } = self.tableContainer
                                          .value
                                          .context();

                                      attrs.xData = new DataContainer({});
                                      // attrs.xDisabled = new DataContainer(true);
                                      attrs.dataProvider = {
                                          getData:  () => {
                                              return coreApiClient.call(
                                                  "tariffs",
                                                  "findAll",
                                                  {
                                                      payload: JSON.stringify({
                                                          limit: -1,
                                                          orderBy: "name",
                                                          orderType: "asc",
                                                          filters: [
                                                          {
                                                              key: "charging_station_id",
                                                              operator: "equal_to",
                                                              value: chagingStation.id,
                                                          },
                                                          {
                                                              key: "connector_id",
                                                              operator: "equal_to",
                                                              value: connector.connectorId,
                                                          },
                                                        ],
                                                      }),
                                                      }
                                              ).then(({items}) => {
                                                  if (items.length === 0) {
                                                      return;
                                                  }
                                                  const xData = {
                                                      _id: items[0]?._id,
                                                      elements: items[0]?.elements.map((el) => {
                                                          return {
                                                              type: el.price_components[0]?.type,
                                                              step_size: el.price_components[0]?.step_size,
                                                              vat: el.price_components[0]?.vat,
                                                              start_time: el.restrictions?.start_time,
                                                              end_time: el.restrictions?.end_time,
                                                              price: el.price_components[0]?.price,

                                                              min_duration: el.restrictions?.min_duration,
                                                              max_duration: el.restrictions?.max_duration,
                                                              price_parking: el.price_components[0]?.price,
                                                          }
                                                      })
                                                  }

                                                  return xData;
                                              });
                                          }
                                      }
                                      return attrs;
                                  },
                                  attrs: {
                                      xOptions: {
                                          content: {
                                              sections: {
                                                  default: {
                                                      fields: {
                                                          elements: {
                                                              type: "XArrayInput",
                                                              attrs: {
                                                              label: "Elements",
                                                              required: true,
                                                              xOptions: {
                                                                  content: {
                                                                  itemLabel: (_, index) => {
                                                                      return `Elements ${+index + 1}`;
                                                                  },
                                                                  itemProperties: {
                                                                      type: {
                                                                        type: "select",
                                                                        attrs: {
                                                                            label: "Type",
                                                                            items: elementTypeItems,
                                                                            required: true,
                                                                            options: {
                                                                            transform(_, item) {
                                                                                console.log("item", item);
                                                                                const price_components = item.price_components;
                                                                                return price_components[0]?.type;
                                                                            },
                                                                            },
                                                                        },
                                                                        ext: {
                                                                          defaultValue: "ENERGY",
                                                                          onInput: (value, self) => {
                                                                              self.options.content.sections.default.fields.start_time.ext.hidden = value !== 'ENERGY'
                                                                              self.options.content.sections.default.fields.end_time.ext.hidden = value !== 'ENERGY'
                                                                              self.options.content.sections.default.fields.price.ext.hidden = value !== 'ENERGY'

                                                                              self.options.content.sections.default.fields.step_size.ext.hidden = value !== 'PARKING_TIME'
                                                                              self.options.content.sections.default.fields.min_duration.ext.hidden = value !== 'PARKING_TIME'
                                                                              self.options.content.sections.default.fields.max_duration.ext.hidden = value !== 'PARKING_TIME'
                                                                              self.options.content.sections.default.fields.price_parking.ext.hidden = value !== 'PARKING_TIME'
                                                                          },
                                                                        },
                                                                      },
                                                                      start_time: {
                                                                        attrs: {
                                                                            label: "Start Time",
                                                                            required: true,
                                                                            rules: [
                                                                                (v) => !!v || 'Start Time is required',
                                                                                (v) => {
                                                                                  const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
                                                                                  return timeRegex.test(v) || 'Invalid time format. Use HH:mm (e.g., 09:30, 14:45)';
                                                                                }
                                                                            ],
                                                                        },
                                                                        ext: {
                                                                            hidden : false
                                                                        },
                                                                      },
                                                                      end_time: {
                                                                        attrs: {
                                                                            label: "End Time",
                                                                            required: true,
                                                                            rules: [
                                                                                (v) => !!v || 'Start Time is required',
                                                                                (v) => {
                                                                                  const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
                                                                                  return timeRegex.test(v) || 'Invalid time format. Use HH:mm (e.g., 09:30, 14:45)';
                                                                                }
                                                                            ],
                                                                        },
                                                                        ext: {
                                                                            hidden : false
                                                                        },
                                                                      },
                                                                      price: {
                                                                          type: "number",
                                                                          attrs: {
                                                                              label: "Price(per kWh)",
                                                                              required: true,
                                                                              min: 0,
                                                                              suffix: "per kWh",
                                                                          },
                                                                          ext: {
                                                                            defaultValue: 0,
                                                                            hidden : false
                                                                          },
                                                                      },
                                                                      step_size: {
                                                                          type: "number",
                                                                          attrs: {
                                                                              label: "Step Size (seconds)",
                                                                              required: true,
                                                                              min: 0,
                                                                          },
                                                                          ext: {
                                                                              defaultValue: 60,
                                                                              hidden : false
                                                                          },
                                                                      },
                                                                      min_duration: {
                                                                          type: "number",
                                                                          attrs: {
                                                                              label: "Minimum Duration (seconds)",
                                                                              required: true,
                                                                              min: 0,
                                                                          },
                                                                          ext: {
                                                                              defaultValue: 0,
                                                                              hidden : false
                                                                          },
                                                                      },
                                                                      max_duration: {
                                                                          type: "number",
                                                                          attrs: {
                                                                              label: "Maximum Duration (seconds)",
                                                                              min: 0,
                                                                          },
                                                                          ext: {
                                                                              defaultValue: 0,
                                                                              hidden : false
                                                                          }
                                                                      },
                                                                        price_parking: {
                                                                          type: "number",
                                                                          attrs: {
                                                                              label: "Price(per step)",
                                                                              required: true,
                                                                              min: 0,
                                                                              suffix: "per step",
                                                                          },
                                                                          ext: {
                                                                              defaultValue: 0,
                                                                              hidden : false
                                                                          },
                                                                      },
                                                                  },
                                                                  template: {
                                                                      formOptions: {
                                                                      content: {
                                                                          colLength: 12,
                                                                          rules: [
                                                                            (v) => {
                                                                                if (v.type === "PARKING_TIME" && v.max_duration && v.min_duration >= v.max_duration) {
                                                                                    throw new Error("Min duration must be less than max duration");
                                                                                }
                                                                            },
                                                                          ],
                                                                      },
                                                                      },
                                                                  },
                                                                  },
                                                              },
                                                              },
                                                          },
                                                      }
                                                  }
                                              }
                                          }
                                      }
                                  },
                              },
                              buttons: {
                                  save: {
                                      content: {
                                          text: "Save",
                                      },
                                      states: {},
                                      on: {
                                          async xClick({self: buttonSelf}) {
                                              const dialog = buttonSelf.context();
                                              const { item: connector } = dialog
                                                  .context()
                                                  .context();

                                              const { item: chagingStation } = self.tableContainer
                                                  .value
                                                  .context();
                                              const form = dialog.contentContainer.value;
                                              const data = form.getData();
                                              const {_id, elements} = data;

                                              const updatedElements = elements.map((el) => {
                                                  if (el.type === "PARKING_TIME") {
                                                      return {
                                                          price_components: [
                                                          {
                                                              type: el.type,
                                                              step_size: el.step_size,
                                                              price: el.price_parking,
                                                          },
                                                          ],
                                                          restrictions: {
                                                              min_duration: el.min_duration,
                                                              max_duration: el.max_duration,
                                                          },
                                                      }
                                                  }
                                                  return {
                                                      price_components: [
                                                      {
                                                          type: el.type,
                                                          price: el.price,
                                                      },
                                                      ],
                                                      restrictions: {
                                                      start_time: el.start_time,
                                                      end_time: el.end_time,
                                                  },
                                              }});
                                              let result;
                                              if (!_id) {
                                                  // Create new tariff
                                                  result = await coreApiClient.call(
                                                      "tariffs",
                                                      "create",
                                                      {},
                                                      {
                                                          charging_station_id: chagingStation.id,
                                                          connector_id: connector.connectorId,
                                                          elements: updatedElements,
                                                      }
                                                  );
                                              } else {
                                                  result = await coreApiClient.call(
                                                      "tariffs",
                                                      "update",
                                                      {
                                                          id: _id,
                                                      },
                                                      {
                                                          data: {
                                                              elements: updatedElements,
                                                          },
                                                      }
                                                  );
                                              }
                                              if (result) {
                                                  dialog.hide();
                                                  self.tableContainer.value.refresh();
                                              }
                                          },
                                      },
                                  },
                              },
                          }
                      },
                  },
              },
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll() {
              let items =
                (self.updatedItem.details &&
                  self.updatedItem.details.connectors) ||
                [];

              // Smart-socket không qua OCPP BootNotification → details.connectors rỗng.
              // Derive row từ connectorSettingItems để hiện action bind/unbind Napas merchant.
              if (items.length === 0 && self.updatedItem.connectorSettingItems?.length > 0) {
                items = self.updatedItem.connectorSettingItems.map((cs, idx) => ({
                  connectorId: Number(cs.connectorId) || (idx + 1),
                  status: "Available",
                  type: cs.type,
                }));
              }

              if (userManager.checkRole(["user"], true)) {
                items = items.filter(({ connectorId }) => {
                  const connectorItem = self.item.connectorItems.find(
                    ({ connectorId: id }) => id === connectorId
                  );
                  return (
                    connectorItem?.activeUserId ===
                    userManager.getUserInfo()._id
                  );
                });
              }
              return [items, items.length];
            },
          },
        },
      },
    };
  },
  created() {
    const self = this;
    const channelName = `private-chargingStations-tenantId=${this.item.tenantId}-uniqueId=${this.item.uniqueId}`;
    const socketId = userManager.getUserInfo()._id;

    const centrifuge = centrifugeClientFactory(null, async () => {
      const {
        auth
      } = await coreApiClient.call("chargingStations", "subscribe", {
        socketId,
        channelName,
        id: self.item._id,
      });
      return auth;
    });
    this.centrifuge = centrifuge;

    this.updatedItem = { ...this.item };

    const sub = centrifuge.newSubscription(channelName);
    sub.on("publication", (ctx) => {
      const data = (ctx.data);
      self.$set(self, "updatedItem", merge.clone(self.updatedItem, data));
      self.tableContainer.value.refresh();
    });
    sub.subscribe();
    centrifuge.connect();
  },
  destroyed() {
    if (this.centrifuge) {
      this.centrifuge.disconnect();
    }
  },
  watch: {
    item: {
      deep: true,
      handler(newItem) {
        this.$set(this as any, "updatedItem", { ...newItem });
        this.$nextTick(() => {
          const tc = (this as any).tableContainer;
          if (tc?.value?.refresh) tc.value.refresh();
        });
      },
    },
  },
  methods: {
    async openAssignDialog(connectorId: number) {
      this.assignForm = { connectorId, napasMerchantId: "" };
      this.availableMerchants = [];
      this.assignDialog = true;
      await this.loadAvailableMerchants();
    },
    closeAssignDialog() {
      this.assignDialog = false;
    },
    async loadAvailableMerchants() {
      this.loadingMerchants = true;
      try {
        const response = await coreApiClient.call(
          "napasMerchants",
          "findAvailable",
          {
            includeGlobal: true,
            payload: JSON.stringify({
              limit: -1,
              orderBy: "napasMerchantId",
              orderType: "asc",
            }),
          }
        );
        this.availableMerchants = response?.items || [];
      } catch (e) {
        this.showNapasSnackbar(
          (e as any)?.response?.data?.message || "Failed to load merchants",
          "error"
        );
      } finally {
        this.loadingMerchants = false;
      }
    },
    async submitAssign() {
      if (!this.assignForm.napasMerchantId) {
        this.showNapasSnackbar("Please select a merchant", "error");
        return;
      }
      this.assignLoading = true;
      try {
        await coreApiClient.call(
          "napasMerchants",
          "bind",
          { napasMerchantId: this.assignForm.napasMerchantId },
          {
            chargingStationId: (this as any).item._id,
            connectorId: this.assignForm.connectorId,
          }
        );
        await this.reloadStation();
        this.showNapasSnackbar("Assigned successfully", "success");
        this.closeAssignDialog();
      } catch (e) {
        this.showNapasSnackbar(
          (e as any)?.response?.data?.message || "Assign failed",
          "error"
        );
      } finally {
        this.assignLoading = false;
      }
    },
    async reloadStation() {
      try {
        const fresh = await coreApiClient.call(
          "chargingStations",
          "findById",
          { id: (this as any).item._id }
        );
        if (!fresh) return;
        this.$set(this as any, "updatedItem", fresh);
        this.$emit("station-updated", fresh);
        this.$nextTick(() => {
          const tc = (this as any).tableContainer;
          if (tc?.value?.refresh) tc.value.refresh();
          this.$forceUpdate();
        });
      } catch (e) {
        // ignore, optimistic state still applied
      }
    },
    patchConnectorSetting(connectorId: number, patch: Record<string, any>) {
      const current = (this as any).updatedItem;
      if (!current) return;
      const items = ((current.connectorSettingItems || []) as any[]).map(
        (ci) => ({ ...ci })
      );
      const idx = connectorId - 1;
      items[idx] = { ...(items[idx] || {}), ...patch };
      const nextDetails = {
        ...(current.details || {}),
        connectors: [...((current.details && current.details.connectors) || [])],
      };
      const next = {
        ...current,
        connectorSettingItems: items,
        details: nextDetails,
      };
      this.$set(this as any, "updatedItem", next);
      this.$nextTick(() => {
        const tc = (this as any).tableContainer;
        if (tc?.value?.refresh) tc.value.refresh();
        this.$forceUpdate();
      });
    },
    showNapasSnackbar(text: string, color: string) {
      this.napasSnackbar = { show: true, text, color };
    },
  },
});
